import { ExternalCalendarEvent, ID } from '@griply/types';

export type ExternalEventPatch = Partial<
  Pick<ExternalCalendarEvent, 'start' | 'end' | 'title'>
>;

// The optimistic-update transform for one cached events window. The merge is key-by-key on
// purpose: the patch is a Partial, so a caller may hand over an explicit `title: undefined`
// (a drag sends boundaries only), and a plain spread would widen that absent key to
// `undefined` and blank the cached title instead of leaving it alone.
export const patchExternalEventInWindow = (
  events: ExternalCalendarEvent[] | undefined,
  eventId: ID,
  patch: ExternalEventPatch,
): ExternalCalendarEvent[] | undefined =>
  events?.map((event) =>
    event.id === eventId
      ? {
          ...event,
          ...(patch.title === undefined ? {} : { title: patch.title }),
          ...(patch.start ? { start: patch.start } : {}),
          ...(patch.end ? { end: patch.end } : {}),
        }
      : event,
  );
